import React from 'react';
import Add from './Add';

const Edit = ({ data, handleClick }) => {
  console.log("data", data);
  return <Add data={data} handleClick={handleClick} />;
};

export default Edit;
